var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselectShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160512",
    "data-name": "Group 160512",
    transform: "translate(-400 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1911",
    "data-name": "Rectangle 1911",
    width: 16,
    height: 16,
    transform: "translate(400 104)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(-718 -404.79)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1127 511.79)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1122 515.79)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1127 518.79)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    transform: "translate(1124.807 514.505)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 2.088,
    y2: 1.892,
    transform: "translate(0 3.517)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x1: 2.083,
    y2: 1.892,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectShareIcon);
export default __webpack_public_path__ + "static/media/MultiselectShare-icon.a48c2994df2f3014754ba4d00c06f318.svg";
export { ForwardRef as ReactComponent };